<div class="form-for-adyen-cvv" #formWrapper [id]="formName"
    [hidden]="(adyenConfigState$ | async)?.hasSucceeded === false">
    <label class="form-for-adyen-cvv__container" [ngClass]="{'is-touched': touched.encryptedSecurityCode}">
        <!-- <span class="form-for-adyen-cvv">CVV/CVC:</span> -->
        <span data-cse="encryptedSecurityCode" class="form-for-adyen-cvv__input-holder"></span>
        <shared-hint-with-indicator *ngIf="fieldsStatus.encryptedSecurityCode" [hintsSize]="hint.size"
            [hintsFeel]="hint.feel" [hintsVSide]="hint.vside" [hintsHSide]="hint.hside"
            [messages]="fieldsStatus.encryptedSecurityCode" class="form-for-adyen-cvv__errors">
        </shared-hint-with-indicator>
    </label>

    <ng-template #actions>
        <shared-forms-columns align="start" [itemsMargin]="true">
            <shared-forms-submit [disabled]="!isValid" (onClick)="handleOnSubmit($event)"
                [loading]="isMakingRequests$ | async" [width]="buttonWidth" [size]="buttonSize"
                [marginTop]="modal ? null : 'md'">{{labelSubmit}}
            </shared-forms-submit>

        </shared-forms-columns>
    </ng-template>

    <shared-forms-offset-wrapper *ngIf="modal" [topOffset]="false" [modalOffset]="modal" [left]="actions">
    </shared-forms-offset-wrapper>

    <ng-container *ngIf="!modal">
        <ng-container *ngTemplateOutlet="actions"></ng-container>
    </ng-container>

</div>

<shared-loader-for-spinner *ngIf="(adyenConfigState$ | async)?.isDownloading === true"></shared-loader-for-spinner>
